import { useState } from "react";
import { Tabs } from "antd";
import { BarChartOutlined, CalendarOutlined, LineChartOutlined, DashboardOutlined } from "@ant-design/icons";

import { IntelligenceDto } from "dtos/application.dto";
import NetAnalytics from "./charts/NetAnalytics";
import MonthlyAnalytics from "./charts/MonthlyAnalytics";
import WeeklyAnalytics from "./charts/WeeklyAnalytics";
import DailyAnalytics from "./charts/DailyAnalytics";

type OverViewProps = {
  data: IntelligenceDto;
};

const OverView = ({ data }: OverViewProps) => {
  const [activeTab, setActiveTab] = useState("net");

  const tabItems = [
    {
      key: "net",
      icon: <DashboardOutlined />,
      label: "Net",
      children: <NetAnalytics data={data} />,
    },
    {
      key: "monthly",
      icon: <CalendarOutlined />,
      label: "Monthly",
      children: <MonthlyAnalytics data={data} />,
    },
    {
      key: "weekly",
      icon: <BarChartOutlined />,
      label: "Weekly",
      children: <WeeklyAnalytics data={data} />,
    },
    {
      key: "daily",
      icon: <LineChartOutlined />,
      label: "Daily",
      children: <DailyAnalytics data={data} />,
    },
  ];

  return (
    <div className="p-4 bg-white ">
      <Tabs activeKey={activeTab} onChange={setActiveTab} items={tabItems} size="large" className="bg-white" />
    </div>
  );
};

export default OverView;
